import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DC from "../../common/DataConnector";
import { i18n } from "../../lang/i18n";
import { changeAddressAndLoadTransportPrice } from "../../store/Cart/Cart";
import CustomerAddress from "../Customer/Address/CustomerAddress";
import { reducerCartClear } from "../../store/Cart/CartReducer";
import { useAppDispatch } from "../../store/hooks";

interface Props {
    isReady: boolean,
    onStepContinue: () => void
}

export default function DeliveryStepAddress(props: Props) {
    const dispatch = useAppDispatch()
    const navigate = useNavigate();
    const [addresses, setAddresses] = useState<any[]>([])
    const [address, setAddress] = useState<any>(undefined)
    const [addressSelected, setAddressSelected] = useState<any>(undefined)

    useEffect(() => {
        (async function () {
            await loadData()
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function loadData() {
        let content = await DC.Get('/customer/addresses', {});
        if (content.wasOk) {
            setAddresses(content.data);
        }
    }

    function onAddClick() {
        setAddress({
            addressId: 0, contactFullName: '', contactPhone: ''
            , addressLine1: '', addressLine2: '', cp: '', city: { code: '', name: '' }
            , province: { code: '', name: '' }, notes: '', isDefault: true
        })
    }
    function onClearClick(e: any) {
        e.preventDefault();
        dispatch(reducerCartClear());
        navigate('/')
    }


    function onEditClose() {
        loadData()
        setAddress(undefined)
    }

    function onContinue(address: any) {
        if (!address)
            address = addresses[0]
        setAddressSelected(address)
        changeAddressAndLoadTransportPrice(dispatch, address, () => {
            props.onStepContinue()
        });
    }


    if (props.isReady)
        return <div className="row p-3">
            <div className="col">
                <div><b>{addressSelected.contactFullName}</b></div>
                <div>{addressSelected.addressLine1}</div>
                <div>{addressSelected.addressLine2}</div>
                <div>{addressSelected.city.name}</div>
                <div>{addressSelected.cp} - {addressSelected.province.name}</div>
                <div>{i18n.CustomerAddress.ContactPhoneLine}: {addressSelected.contactPhone}</div>
            </div>
        </div>

    return <div className="row p-3">
        {!address && <>
            <div className="col-12 addresses">
                {addresses.map((item: any, index: number) => (
                    <div key={index} className="address">
                        {item.isDefault && <span className="address-default">{i18n.CustomerAddress.DefaultAddress}</span>}
                        <div><b>{item.contactFullName}</b></div>
                        <div>{item.addressLine1}</div>
                        <div>{item.addressLine2}</div>
                        <div>{item.city.name}</div>
                        <div>{item.cp} - {item.province.name}</div>
                        <div>{i18n.CustomerAddress.ContactPhoneLine}: {item.contactPhone}</div>
                        {index > 0 && <div>
                            <button className="btn" onClick={() => { onContinue(item); }}>{i18n.CartDeliveryStepAddress.UseThisAddress}</button>
                        </div>}
                    </div>
                ))}
            </div>
            <div className="col-6">
                <button type="button" className="btn btn-link" style={{ color: 'gray' }}
                    onClick={onClearClick}>
                    <i className="fa fa-trash-alt" /> {i18n._BTNs.Cancel}
                </button>
            </div>
            <div className="col-6 text-right">
                <button className="btn" onClick={onAddClick}>{i18n.CustomerAddress.AddAddress}</button>
            </div>
            {addresses.length > 0 && <> <div className="col-12 mt-4 text-center">
                <button className="btn btn-warning" style={{ minWidth: 250 }}
                    onClick={() => onContinue(undefined)}>{i18n._BTNs.Continue}
                </button>
            </div>
            </>}
        </>}
        {address && <CustomerAddress address={address} onClose={onEditClose} showBack={false} />}
    </div>
}